<template>
  <span>
    <el-button type="primary" plain size="mini" @click="dialogVisible = true">Edit</el-button>
    <el-dialog title="Edit Variant" :visible.sync="dialogVisible">
      <el-form :model="form" :rules="rules" ref="form" label-position="top" @submit.prevent.native="onSubmit">
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <el-form-item label="Barcode" prop="barcode_value">
              <el-input v-model="form.barcode_value" class="input-select">
                <el-select v-model="form.barcode_type" slot="append" placeholder="Select barcode type">
                  <el-option label="EAN" value="EAN"></el-option>
                  <el-option label="UPC" value="UPC"></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <el-form-item label="Color">
              <el-input v-model="form.color"></el-input>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6 col-lg-4">
            <el-form-item label="Size">
              <el-input v-model="form.size"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3">
            <el-form-item label="Width">
              <el-input v-model="form.width">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-form-item label="Height">
              <el-input v-model="form.height">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-form-item label="Length">
              <el-input v-model="form.length">
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </div>
          <div class="col-12 col-md-6 col-lg-3">
            <el-form-item label="Net weight">
              <el-input v-model="form.weight">
                <template slot="append">grams</template>
              </el-input>
            </el-form-item>
          </div>
        </div>
        <el-button native-type="submit" type="primary" :loading="loading">Save</el-button>
        <el-button @click="onCancel">Cancel</el-button>
      </el-form>
    </el-dialog>
  </span>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        barcode_value: this.variant.barcode.value,
        barcode_type: this.variant.barcode.type,
        color: this.variant.color,
        size: this.variant.size,
        width: this.variant.width,
        height: this.variant.height,
        length: this.variant.length,
        weight: this.variant.weight,
      },
      rules: {
        'barcode_value': [
          { required: true, message: 'Enter the product barcode.', trigger: 'blur' },
        ],
      },
    }
  },

  props: {
    variant: Object,
  },

  methods: {
    onSubmit() {

      this.$refs['form'].validate(async valid => {
        if (!valid) {
          return false
        }

        this.loading = true

        try {
          var { data } = await this.$http.put(`/product-variants/${ this.variant.id }`, this.form)
        } catch(err) {
          this.$message.error(err.response.data.message)
          return false
        } finally {
          this.loading = false
        }

        this.dialogVisible = false
        this.$refs['form'].resetFields()
        this.$emit('update')
        this.$message.success(data.message)
      })
    },

    onCancel() {
      this.dialogVisible = false
      this.$refs['form'].resetFields()
    },
  },
}
</script>

<style>
.input-select .el-input-group__append {
  width: 100px;
  padding: 0;
}

.input-select .el-select {
  margin: -10px 0;
  text-align: right;
}
</style>
